<div class="cm__container is-fullwidth">
  <div class="cm__container__col emulate-user">
    <div class="cm__emulate-user__inactive">
      <div class="cm__sub-heading cm__emulate-user__heading" role="heading" aria-level="2">
        {{ userEmulated ? 'Stop Emulating User' : 'Begin Emulating User' }}
      </div>
      <div class="cm__emulate-user__instruction" *ngIf="!userEmulated">
        <p style="margin-bottom: 0">
          Enter a valid user id and click the button to begin user emulation.&nbsp; You will only be able to emulate
          advisors that have logged into the site.
        </p>
        <br />
        <p>
          To emulate one of the sales tools, or to look up an advisor’s user id, use the
          <a
            rel="noopener noreferrer"
            href="https://membersproductsdemo.cunamutual.com/wmadvisorinfo/support/#/"
            target="_blank"
            class="sale-support-link"
            >Advisor Sales Tool Support</a
          >
          site.&nbsp;
        </p>
      </div>

      <div class="cm__emulate-user__info" *ngIf="userEmulated">
        <h2>Currently emulating the following user:</h2>
        <h3>
          <strong> Name: </strong>{{ userDetails.firstName + ' ' + userDetails.lastName }}<br />
          <strong>User ID: </strong>{{ userDetails.userId }}
        </h3>
      </div>
      <form>
        <div class="cm__emulate-user__form-row form-group form-floating" *ngIf="!userEmulated">
          <input
            class="form-control"
            [ngClass]="{
              'cm__emulate-user--error': (!userEmulated && formSubmitted && userId === '') || errorMessage !== '',
            }"
            aria-label="User ID"
            [(ngModel)]="userId"
            type="text"
            id="cm__emulate-user__id"
            name="cm__emulate-user__id"
            placeholder="User ID"
            value=""
            (input)="onSearch()"
          />
          <svg
            *ngIf="errorMessage !== ''"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            style="position: absolute; right: 7%; top: 25%"
          >
            <g id="Error">
              <circle id="Ellipse 8" cx="8" cy="8" r="7.5" stroke="#D0021B"></circle>
              <path
                id="!"
                d="M7 3H9.002L8.638 10.28H7.364L7 3ZM8.96 13.15H7.042V11.358H8.96V13.15Z"
                fill="#D0021B"
              ></path>
            </g>
          </svg>
          <label for="cm__emulate-user__id">User ID</label>
        </div>
        <button
          type="submit"
          (click)="userEmulated ? stopEmulation() : emulateUser()"
          class="cm__button cm__button--arrow cm__button--tertiary"
        >
          {{ userEmulated ? 'Stop Emulating User' : 'Begin Emulating User' }}
        </button>
        <div class="cm__emulate-user__erro-message" *ngIf="!userEmulated && formSubmitted" role="alert">
          {{ errorMessage }}
        </div>
      </form>
    </div>
  </div>
</div>
